<template>
  <div class="home-news">
    <div class="container">
   <div>
    <div class="home-news-title">{{ $t("home.news") }}</div>
<!--    <div class="home-news-more">更多</div>-->
      </div>
<div class="home-news-line"></div>

      <div class="home-news-list" v-for="news in homeNewsList" :key="news.id">
        <div class="home-news-border" @click="toCompanyNewsContent(news.id)">
          <div class="home-news-name" v-show="news.title">{{news.title ? (news.title.length <= 50 ? news.title : news.title.substring(0,50) + "...") : ''}}</div>
          <div class="home-news-content" v-show="news.summary">{{news.summary ? (news.summary.length < 60 ? news.summary : news.summary.substring(0,60)+"......") : ''}}</div>
          <div class="home-news-bottom">
            <div class="home-news-time">
              <div class="home-news-time-day" v-show="news.time">{{news.time && news.time.substring(5)}}</div>
              <div class="home-news-time-year" v-show="news.time">{{news.time && news.time.substring(0,4)}}</div>
            </div>
            <div class="home-news-button">
              <img src="../../assets/home/news-button_grey.png">
            </div>
            </div>
          </div>


      </div>

    </div>
  </div>

</template>

<script>
import axios from 'axios'

const HOME_NEWS_IDS = [59, 60]

export default {
  name: 'HomeNews',
  data() {
    return {
      homeNewsList: [],
    }
  },
  created() {
    Promise.all(
      HOME_NEWS_IDS.map((id) =>
        axios.get(process.env.VUE_APP_API_URL + 'news/' + id).then((response) => response.data.data)
      )
    )
      .then((list) => {
        this.homeNewsList = list.filter(
          (news) => news && typeof news.title === 'string' && news.title.trim()
        )
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    toUrl($url) {
      window.location.href = $url
    },
    toCompanyNewsContent($id) {
      this.$router.push({ name: 'CompanyNewsContent', params: { id: $id } })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home-news{
    margin-top: 60px;
    margin-bottom: 60px;
  }
  .home-news-title{
    display: inline-block;
    font-size:32px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(73,145,201,1);
    line-height:45px;
  }
  .home-news-more{
    display: inline-block;
    float: none;
    margin-top: 12px;
    font-size:24px;
    font-family:PingFangSC-Light,sans-serif;
    font-weight:300;
    color:rgba(79,76,77,1);
    line-height:33px;
  }
  .home-news-line{
    margin-top: 8px;
    height:1px;
    background:rgba(240,240,240,1);
  }
  .home-news-list{
    display: inline-block;
    margin-top: 10px;
    margin-left: -15px;
    margin-right: -1px;
  }
  .home-news-border{
    width:540px;
    border:2px solid rgba(240,240,240,1);
    padding: 38px 40px 0px 40px;
    margin: 30px 15px 0px 15px;
    cursor: pointer;
    vertical-align: top;
  }
  .home-news-border:hover,
  .home-news-border:active,
  .home-news-border:focus{
    border:2px solid rgba(73,145,201,1);
  }
  .home-news-name{
    height: 50px;
    overflow: hidden;
    font-size:18px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .home-news-content{
    height: 40px;
    overflow: hidden;
    font-size:14px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:20px;
    margin-top: 18px;
    min-height: 40px;
  }
  .home-news-bottom{
    height:70px;
    background:rgba(240,240,240,1);
    margin-top: 26px;
    margin-left: -40px;
    margin-right: -40px;
    padding: 0 40px 0 40px;
  }
  .home-news-time{
    float: left;
  }
  .home-news-time-day{
    font-size:24px;
    font-family:PingFangSC-Light,sans-serif;
    font-weight:300;
    color:rgba(79,76,77,1);
    line-height:33px;
    margin-top: 11px;
  }
  .home-news-time-year{
    font-size:18px;
    font-family:PingFangSC-Light,sans-serif;
    font-weight:300;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-top: -8px;
  }
  .home-news-button{
    float: right;
    margin-top: 16px;
    width: 36px;
  }
  @media (max-width: 576px) {
    .home-news-border{
      width: calc(100% - 30px);
      padding: 24px 20px 0px 20px;
    }
    .home-news-bottom{
      margin-left: -20px;
      margin-right: -20px;
      padding: 0 20px 0 20px;
    }

  }
  @media (min-width: 576px) and (max-width:768px) {
    .home-news-border{
      width: calc(100% - 30px);
    }
  }

  @media (min-width: 768px) and (max-width:992px) {
    .home-news-border {
      margin: 30px 90px 0 90px;
    }
  }

  @media (min-width: 992px) and (max-width:1200px){
    .home-news-border {
      width: 450px;
    }
  }

  @media (min-width: 1200px) {

  }



</style>
